import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import PasswordResetErrorResponse from './PasswordResetErrorResponse';

export default function resetPassword(client: ApiClient, email: string): Promise<void> {
	return client
		.unauthenticatedFetch('authentication/password/reset', {
			method: 'POST',
			body: JSON.stringify({ email }),
		})
		.catch((response) => ApiClientErrorResponse.wrapError(response, PasswordResetErrorResponse));
}
